import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { spinnerOff, spinnerOn } from '../../../components/Spinner';
import {getProject} from '../../../api';
import { Empty, Table } from 'antd';
import {
  commonFilter,
  commonSorter,
  composeFilters,
} from 'utils/AntdTableFunctions';
import ProgressBarComp from 'containers/common/ProgressBarComp';

function ProjectTaskContainer(props) {
  const [projectTasksData, setProjectTasksData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      spinnerOn();

      const updatedProject = await getProject(props.project.id);
      let projectTasksData2 = [];
      projectTasksData2.push({key:'Pre-Job', compPercent: updatedProject.preJobPercent, inCompPercent: updatedProject.preJobInCompPercent, tempPercent: updatedProject.preJobTempPercent});
      projectTasksData2.push({key:'Post-Job', compPercent: updatedProject.postJobPercent, inCompPercent: updatedProject.postJobInCompPercent, tempPercent: updatedProject.postJobTempPercent});
      if(updatedProject.showSecurityTasks === 1)
      {
        projectTasksData2.push({key:'CIP Security', compPercent: updatedProject.cipsecurityPercent, inCompPercent: updatedProject.cipsecurityInCompPercent, tempPercent: updatedProject.cipsecurityTempPercent});
      }
      if(updatedProject.showRemovalTasks === 1)
      {
        projectTasksData2.push({key:'Removals', compPercent: updatedProject.removalJobPercent, inCompPercent: updatedProject.removalJobInCompPercent, tempPercent: updatedProject.removalJobTempPercent});
      }
      setProjectTasksData(projectTasksData2);

      spinnerOff();
      setLoading(false);
    }
    getData();

    return () => setLoading(true);
  }, [props]);

  let projectTasksDropDownArray = projectTasksData.map((a, i) => {
    return { key: a.key };
  });

  const LinkCellFormatter = (text, record) => {
    const { project, status } = props;
    return (
      <Link
        to={{
          pathname: `/${status}/${project.id}/projecttasks/${record.key}`,
          data: record,
        }}
      >
        {record.key}
      </Link>
    );
  };

  const PercentCellFormatter = (text, record) => {
    return <ProgressBarComp
      progressBarProps={[{ bgcolor: 'green', taskPercent: Number(record.compPercent).toFixed(2) },
      { bgcolor: 'gray', taskPercent: Number(record.inCompPercent).toFixed(2) },
      { bgcolor: 'yellow', taskPercent: Number(record.tempPercent).toFixed(2) }
      ]}
      style={{
        borderRadius: '.25rem',
        height: '1rem',
        overflow: 'hidden',
        fontSize: '.75rem',
        color: 'black'
      }}
      showtext={true}
    />
  };

  const columns = [
    {
      dataIndex: 'key',
      key: 'key',
      title: 'Section',
      render: LinkCellFormatter,
      filters: composeFilters('key', projectTasksDropDownArray),
      onFilter: (value, record) => commonFilter(value, record, 'key'),
      sorter: (a, b) => commonSorter(a, b, 'key'),
    },
    {
      dataIndex: 'list',
      key: 'list',
      title: 'Status',
      render: PercentCellFormatter,
    },
  ];

  return (
    <div
      className='table-responsive project-task-container'
      style={{ overflow: 'hidden' }}
    >

      <Table
        columns={columns}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: loading ? (
            <Empty description={<h6>Loading</h6>} />
          ) : (
            <Empty description={<h6>No Tasks Found</h6>} />
          ),
        }}
        dataSource={projectTasksData}
      />
    </div>
  );
}

export default withRouter(ProjectTaskContainer);
